export const fieldClass = 'mt-1 w-full rounded-xl border border-line bg-shell px-3 py-2 text-sm text-ink outline-none focus:border-brand';

export function Field({
  label,
  value,
  onChange,
  type = 'text',
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
}) {
  return (
    <label className="block text-xs font-medium text-muted">
      {label}
      <input type={type} value={value} onChange={(event) => onChange(event.target.value)} className={fieldClass} />
    </label>
  );
}
